import { EventSource, ModelEvents, ModelMutateCallback, ModelMutation, ModelView } from '@deqo/podopolis';

export interface ObjectManagerBackendStreams {
    modelMutation: ModelEvents['modelMutation'];
    modelOperation: ModelEvents['modelOperation'];
}

export interface ObjectManagerBackend extends EventSource<ObjectManagerBackendStreams> {

    readonly namespace: string;

    generateId(): string;

    getModel(): ModelView;

    getMutation(): ModelMutation;

    mutate(impl: ModelMutateCallback): void;

    shouldAllowCreates(): boolean;

    shouldAutoAllocate(): boolean;
}

export class ObjectManagerCreateNotAllowedError extends Error {
    constructor() {
        super('ObjectManagerCreateNotAllowedError');
    }
}
